import { RequestType, } from '../_types';
export const type = (type) => (request) => {
    if ('type' in request && request.type !== RequestType.Undefined) {
        throw new Error(`Cannot set "${RequestType[type]}" conversion, already set to "${RequestType[request.type]}"`);
    }
    return {
        ...request,
        type,
    };
};
